import { Injectable } from '@angular/core';
import { FormActionService } from '../action.service';

export abstract class FormActionHandlerService {

  constructor() { }

  /**
   * Execute a handler for a generic action
   *
   * @abstract
   * @memberof FormActionHandlerService
   */
  abstract exec(): Promise<any>;

}
